// src/api/cardBackService.js
// Dors de carte cosmétiques : un seul dos actif par joueur, appliqué à tout le deck.
import api from './api';

/** État complet : catalogue + possédés + sélection active */
export const getCardBacks = async () => {
  try {
    const response = await api.get('/shop/cardbacks');
    return response.data;
  } catch (error) {
    // Fallback offline : neutre uniquement
    return {
      success: true,
      selected: 'neutral',
      backs: [{ id: 'neutral', name: 'Sceau de Novarcane', image: '/api/static/images/card-backs/neutral.webp', owned: true, sources: [{ type: 'default', label: 'Par défaut' }] }],
      offline: true,
    };
  }
};

/** Sélectionne le dos actif (doit être possédé) */
export const selectCardBack = async (backId) => {
  const response = await api.post('/shop/cardbacks/select', { backId });
  return response.data;
};

/** Achète un dos à la boutique */
export const buyCardBack = async (backId) => {
  const response = await api.post('/shop/cardbacks/buy', { backId });
  return response.data;
};

/** URL de l'image d'un dos (avec fallback neutre) */
export const cardBackUrl = (backId) =>
  `/api/static/images/card-backs/${backId || 'neutral'}.webp`;

export default { getCardBacks, selectCardBack, buyCardBack, cardBackUrl };
